import axios from '@/utils/request';

const v1 = `v1/admin/dashboard`;
export const getSalePanel = ({ company_id }) => axios.get(`${v1}/salePanel`, { params: { company_id } });
export const getSaleChart = ({ company_id }) => axios.get(`${v1}/saleChart`, { params: { company_id } });
export const getMvmStatus = ({ company_id }) => axios.get(`${v1}/mvmStatus`, { params: { company_id } });
export const getMyMvmStatus = () => axios.get(`${v1}/myMvmStatus`);
export const getMvms = ({ company_id }) => axios.get(`${v1}/mvms`, { params: { company_id } });
export const getSaleOutline = ({ company_id }) => axios.get(`${v1}/saleOutline`, { params: { company_id } });
